import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Divider, Image } from 'components';
import { useMediaQuery } from '@mui/material';
import useTheme from '@mui/system/useTheme';
import Mentions from './mentionedData';
import { MentionedContainer } from './styled';

function Mentioned(): JSX.Element {
  const theme = useTheme();
  const renderMentionGrids = () =>
    Mentions.map((mentionData: Mention, index: number) => (
      <Grid
        data-testid="mention"
        key={index}
        item
        xs={6}
        sm={4}
        md={2}
        padding={index >= 4 ? '0 10px' : '0 10px 20px 10px'}
        textAlign="center">
        <Image
          src={mentionData.src}
          alt={mentionData.alt}
          height={mentionData.height}
          width={mentionData.width}
        />
      </Grid>
    ));

  return (
    <MentionedContainer>
      <Typography className="mentioned-title" variant="h2" component="div">
        As Mentioned In
      </Typography>
      <Grid container alignContent="center" justifyContent="center">
        {renderMentionGrids()}
      </Grid>
      <Divider sizePx={useMediaQuery(theme.breakpoints.up('sm')) ? 50 : 30} />
    </MentionedContainer>
  );
}

export default Mentioned;
